/*
 * @Author: 彭鑫诚
 * @Date: 2024-03-13 18:38:24
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-06-03 08:50:40
 * @Description: 物品库存model
 */
import type {
  IGoodsInventoryModel,
  IGoodsInventoryStore,
} from '@monorepo/types/document/goodsInventory/goodsInventory.types';

const initState: IGoodsInventoryStore = {
  isInit: true,
  tableList: [],
  total: 0,
  inventory_quantity_sum: '0',
  inventory_money_sum: '0',
  base_unit_qty_sum: '0',
  query: {
    location_id_list: [],
    offset: 0,
    limit: 50,
    storehouse_num_list: [],
    variant_id_list: [],
    // 查询维度
    dimension: 'STOREHOUSE',
    // 过滤 or 显示
    filterConditions: 'FILTER',
    // 预警状态
    warn_status: 'NONE',
    query_unit: 'INVENTORY_UNIT',
  },
};

const goodsInventoryModel: IGoodsInventoryModel = {
  namespace: 'goodsInventoryStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default goodsInventoryModel;
